import React from "react";
import { createPortal } from "react-dom";
import "./ModalPopup.css"; // Import CSS for styling
import { useT } from "../i18n";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faChartColumn, faChevronRight, faPhone, faTableCells, faXmark } from "@fortawesome/free-solid-svg-icons";

const SheetOption = ({ icon, title, subtitle, ...linkProps }) => {
  const { t } = useT();
  const content = (
    <>
      <span className="menu-card-icon"><FontAwesomeIcon icon={icon} /></span>
      <span className="menu-card-text">
        <strong>{t(title)}</strong>
        <span>{t(subtitle)}</span>
      </span>
      <span className="menu-card-chevron"><FontAwesomeIcon icon={faChevronRight} /></span>
    </>
  );
  return linkProps.to
    ? <Link className="menu-card sheet-option" {...linkProps}>{content}</Link>
    : <a className="menu-card sheet-option" {...linkProps}>{content}</a>;
};

const CommonModalPopup = ({isOpen,closeModal,data}) => {
  const { t } = useT();
  if (!isOpen || !['CHART_INFO','CONNECT_SUPPORT'].includes(data.content)) return null;

  const isChart = data.content==='CHART_INFO';
  const title = isChart ? t('Chart Info') : t('Contact Support');
  const subtitle = isChart ? data.game_name?.split('_').join(' ') : `+91 ${data.phone}`;

  // Rendered on <body> so no parent layout can clip or hide it
  return createPortal(
    <div className="sheet-overlay" onClick={closeModal}>
      <div className="sheet" role="dialog" aria-modal="true" aria-label={title} onClick={(e)=>e.stopPropagation()}>
        <span className="sheet-handle" aria-hidden="true" />
        <div className="sheet-header">
          <div>
            <h2>{title}</h2>
            {subtitle && <p>{subtitle}</p>}
          </div>
          <button type="button" className="sheet-close" onClick={closeModal} aria-label={t('Close')}>
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <div className="sheet-body">
          {isChart ? (
            <>
              <SheetOption to={`/jodi_chart/${data.game_name}`} icon={faTableCells} title="Jodi Chart" subtitle="Past jodi results" />
              <SheetOption to={`/pana_chart/${data.game_name}`} icon={faChartColumn} title="Pana Chart" subtitle="Past panna results" />
            </>
          ) : (
            <>
              <SheetOption href={`tel:+91${data.phone}`} icon={faPhone} title="Call Now" subtitle="Talk to our support team" />
              <SheetOption href={`https://wa.me/+91${data.phone}?text=Hello !!`} target="_blank" rel="noreferrer" icon={faWhatsapp} title="WhatsApp" subtitle="Chat with us on WhatsApp" />
            </>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CommonModalPopup;
